import { Component } from '@angular/core';
import { DxCellPreparedEvent, DxToolbarPreparingEvent } from '../../../../../core/dx.types';
import { LoggerService } from '../../../../../shared/sdk';
import { CommonService } from '../../../../../shared/modules/my-common/services/common.service';
import { ConfigService } from '../../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../../shared/modules/my-common/services/datasource.service';
import { PusherService } from '../../../../../shared/modules/my-common/services/pusher.service';
import { GridHelperService } from '../../../../../shared/modules/ui/services/grid-helper.service';
import { PushNotificationsService } from '../../../../../shared/modules/ui/services/push-notifications.service';
import { UiService } from '../../../../../shared/modules/ui/services/ui.service';
import { ABaseConsistencyCheckComponent } from '../a-base-consistency-check.component';

@Component({
  selector: 'app-consistency-check4',
  templateUrl: './consistency-check4.component.html',
  styleUrls: ['./consistency-check4.component.scss'],
})
export class ConsistencyCheck4Component extends ABaseConsistencyCheckComponent {
  protected mongoSchema: any = { 'service date': 'datetime', '_claim._ctime': 'datetime', '_claim._rtime': 'datetime' };
  protected checkIdx = 4;

  constructor(
    protected logger: LoggerService,
    protected ui: UiService,
    public config: ConfigService,
    protected pusher: PusherService,
    protected notification: PushNotificationsService,
    protected gridHelper: GridHelperService,
    protected common: CommonService,
    protected dss: DataSourceService,
  ) {
    super(logger, ui, pusher, common, dss, gridHelper);

    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: 'ec048035-fea1-458f-9623-ecaada0fb63e',
    };
  }

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent) {}

  grid_onContextMenuPreparing(e) {}

  grid_onCellPrepared(e: DxCellPreparedEvent) {}
}
